import { render, staticRenderFns } from "./ModalItemGoldDrafting.vue?vue&type=template&id=1e4a9a4e&scoped=true&"
import script from "./ModalItemGoldDrafting.vue?vue&type=script&lang=js&"
export * from "./ModalItemGoldDrafting.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemGoldDrafting.vue?vue&type=style&index=0&id=1e4a9a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a9a4e",
  null
  
)

export default component.exports